import React from "react";

const legalStyles = `
.legal-hero { background: linear-gradient(90deg,#0b5fa8 0%,#0d84d6 100%); color: #fff; padding: 18px 0; display:flex; align-items:center; justify-content:center; text-align:center; }
.legal-hero h1 { font-size: 1.5rem; margin: 0 0 6px; }
.legal-hero p { font-size: 1rem; margin: 0; opacity: 0.95; }
.legal-hero .legal-meta { margin-top: 8px; font-size: 12px; color: rgba(255,255,255,0.9); }
.legal-container { max-width: 820px; margin: 0 auto; padding: 20px 18px; }
.legal-card { background: #fff; border-radius: 8px; padding: 22px; box-shadow: 0 6px 24px rgba(12,22,38,0.06); }
.legal-card h2 { color: #0b5fa8; margin-bottom: 12px; font-size: 1.25rem; }
.legal-card h3 { color: #0f6fb2; margin-top: 14px; margin-bottom: 8px; }
.legal-card p { color: #374151; line-height: 1.7; margin-bottom: 12px; }
@media (max-width:640px) { .legal-hero { padding: 16px 0; } .legal-container { padding: 14px; } }
`;

const TermsOfUse = () => {
  return (
    <div className="min-h-screen bg-gray-50 font-roboto text-gray-800">
      <style>{legalStyles}</style>
      {/* Hero Section */}
      <div className="legal-hero">
        <div className="container mx-auto px-4">
          <h1>Terms of Use</h1>
          <div className="legal-meta">Last updated: January 1, 2026</div>
        </div>
      </div>

      {/* Content */}
      <div className="legal-container">
        <div className="legal-card">
          <h2 className="text-3xl font-bold mb-4">Terms of Use</h2>

          <section className="mb-8">
            <p className="mb-4 leading-relaxed">
              The website <strong>www.lextria.in</strong> ("Website") is owned
              by An Lextria Innovative Solutions ("Lextria Research" or the
              "Firm") and is for general informational purposes only. By
              accessing any content in this Website, the end user (referred to
              herein as "you", "your", or the "User") acknowledges that the
              information provided does not amount to advertising or
              solicitation and is meant only for your understanding about the
              activities of LEXTRIA RESEARCH.
            </p>
            <p className="leading-relaxed">
              By using the Website, you specifically agree to be bound by these
              Terms of Use ("Terms of Use") and the Privacy Policy. If you do
              not agree or are not willing to be bound by the Terms of Use and
              the Privacy Policy, please do not click on the "check box" and on
              the "Submit / Agree" button and do not seek to obtain access to or
              otherwise use the Website.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              General Information
            </h3>
            <p className="mb-4 leading-relaxed">
              All content on this Website has been checked for accuracy.
              However, LEXTRIA RESEARCH does not accept any responsibility for
              any loss or damage which may arise from accessing or reliance on
              information published on this Website. Further, views/ opinions/
              articles/ information/ discussion and other such content provided
              in this Website, whether by LEXTRIA RESEARCH or third parties, do
              not constitute legal advice or opinion. The views expressed in the
              discussions, featured articles and other such content in this
              Website represent the personal view of the author(s) and do not,
              in any manner, constitute the views of LEXTRIA RESEARCH.
            </p>
            <p className="leading-relaxed">
              LEXTRIA RESEARCH reserves the right to delete, modify, or
              supplement the content of the Website at any time for any reason
              without prior notification, and will use reasonable efforts to
              include up-to-date and accurate information on the Website.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              License and Use of the Website
            </h3>
            <p className="mb-4 leading-relaxed">
              Subject to the Terms of Use, LEXTRIA RESEARCH hereby grants you a
              non-transferable, non-exclusive, revocable, limited license to
              access and use the Website. LEXTRIA RESEARCH may, from time to
              time, update or modify the Website, release new versions of the
              Website, which may, at LEXTRIA RESEARCH's discretion, be included
              within the license described above. You shall not be permitted to
              sublicense or transfer any of your rights and/or obligations
              hereunder including, without limitation, access to the Website.
            </p>
            <p className="mb-4 leading-relaxed">
              You shall not directly or indirectly copy or reproduce all or any
              part of the Website, whether electronically, mechanically or
              otherwise, in any form including, but not limited to, the copying
              of presentation, style or organization, uploading, posting, or
              transmitting any content which constitutes the intellectual
              property of another party, for which you do not have a right to
              make available; uploading, posting, or transmitting any material
              that contains software viruses or any other computer code, files
              or programs designed to interrupt, destroy or limit the
              functionality of any computer software or hardware or
              telecommunications equipment.
            </p>
            <p className="leading-relaxed">
              LEXTRIA RESEARCH reserves the right to prevent or restrict access
              to the Website. Any unauthorized use by you shall terminate the
              permission or license granted to you by LEXTRIA RESEARCH. Using
              this Website and by accepting the terms and conditions of Terms of
              Use you also agree that you shall not hack or hire some third
              party to hack the Website or even use any other unauthorized means
              to access any third-party information without written consent of
              LEXTRIA RESEARCH. You shall in such an event be liable for a
              criminal offence and LEXTRIA RESEARCH shall institute appropriate
              legal proceedings to claim damages. In case any misuse of the
              Website is conducted by a person or entity based out of India,
              LEXTRIA RESEARCH reserves the right to institute proceedings in
              accordance with the laws relating to Intellectual Property Rights.
              You shall use the Website solely for its intended purposes and
              shall not use the Website for the benefit of any third party
              except as specifically contemplated under these Terms of Use and
              the Privacy Policy.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Intellectual Property
            </h3>
            <p className="leading-relaxed">
              Unless otherwise stated, all intellectual property rights,
              including copyright, trademarks, patents in this Website and its
              contents including news articles, featured articles and
              discussions ("Content") are owned, licensed to, or otherwise used
              by LEXTRIA RESEARCH as permitted under applicable law. The
              information provided on this Website is provided solely for
              private use and not for any commercial or public use. You may
              download or print hard copies of any part of the content on this
              Website for your personal use. Except where your use is expressly
              permitted above or by copyright law, you may not otherwise copy,
              store in any medium (including any other web site), distribute,
              transmit, re-transmit, broadcast, modify or show in public any
              part of this Website without the prior written permission of
              LEXTRIA RESEARCH.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Privacy
            </h3>
            <p className="mb-4 leading-relaxed">
              We do not sell or rent your personal information to third parties
              for their marketing purposes without your explicit consent and we
              only use your information as described in the Privacy Policy. We
              view protection of User's privacy as an important community
              principle. We understand clearly that you and your Personal
              Information is one of our most important assets. Your Information
              which is stored and processed by us is protected by physical as
              well as reasonable technological security measures and procedures.
              If you object to the Privacy Policy in any way, please do not use
              the Website.
            </p>
            <p className="leading-relaxed">
              By accepting the Privacy Policy, you hereby consent to your
              information being shared on a no-name basis with third parties.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Communication Between Users
            </h3>
            <p className="leading-relaxed">
              When you use the Website or send an email or other data,
              information or communication to LEXTRIA RESEARCH, you agree and
              understand that you are communicating with LEXTRIA RESEARCH
              through electronic records and you consent to receive
              communications via electronic records from LEXTRIA RESEARCH
              periodically and as and when required. LEXTRIA RESEARCH will
              communicate with you by email or by notifications on the Website
              which will be deemed adequate service of notice/ electronic
              record.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Changes to the Terms of Use
            </h3>
            <p className="leading-relaxed">
              LEXTRIA RESEARCH may from time to time amend the Terms of Use. Any
              changes will be posted on our website
              <strong> www.lextria.in</strong> and we will endeavor to notify
              you of the same by means of a notice and link to the revised terms
              on our website. Any changes to our Terms of Use will be
              communicated through our website at least ten (10) days in advance
              of implementation. Users are bound by any changes to the Terms of
              Use when they use the Website after such changes have been first
              posted. If you do not agree to such changes, you should not make
              any subsequent use of the Website.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Monitoring
            </h3>
            <p className="leading-relaxed">
              LEXTRIA RESEARCH shall have the right, but not the obligation, to
              always monitor the content of the Website, to determine compliance
              with this Terms of Use and any operating rules established by
              LEXTRIA RESEARCH, as well as to satisfy any applicable law,
              regulation, or authorized government request. Without limiting the
              foregoing, LEXTRIA RESEARCH shall have the right to remove any
              material that LEXTRIA RESEARCH, in its sole discretion, finds to
              be in violation of the provisions hereof or otherwise
              objectionable.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              External Links
            </h3>
            <p className="leading-relaxed">
              The Website may contain links to other third-party internet sites
              providers. The availability of such third-party sites, services or
              material does not constitute any form of recommendation, advice,
              endorsement, or publication of any such third-party sites,
              services, or material and LEXTRIA RESEARCH is not responsible for
              their availability or content.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Governing Law and Dispute Resolution
            </h3>
            <p className="mb-4 leading-relaxed">
              This Terms of Use and the Privacy Policy shall be governed by and
              constructed in accordance with the laws of India only without
              reference to conflict of laws principles and disputes arising in
              relation hereto shall be subject to the exclusive authority of the
              courts of Udupi, Karnataka - India.
            </p>
            <p className="leading-relaxed">
              If any dispute arises between you and LEXTRIA RESEARCH during your
              use of our Website or thereafter, in connection with the validity,
              interpretation, implementation or alleged breach of any provision
              of the Terms of Use and the Privacy Policy, the dispute shall be
              referred to a sole Arbitrator who shall be an independent and a
              neutral third party identified by LEXTRIA RESEARCH. The place of
              arbitration shall be Udupi. The arbitration shall be conducted in
              English Language. The Arbitration & Conciliation Act, 1996, shall
              govern the arbitration proceedings.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Assignability
            </h3>
            <p className="leading-relaxed">
              The Website may assign any of its responsibilities/obligations to
              any other Person without notice to the User, at its sole
              discretion. However, you shall not assign, sub-license or
              otherwise transfer any of your rights or obligations under these
              Terms of Use to any other party, unless a written consent is taken
              from LEXTRIA RESEARCH.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Severability
            </h3>
            <p className="leading-relaxed">
              If any provision of these Terms of Use is found to be invalid, the
              invalidity of that provision will not affect the validity of the
              remaining provisions of the Terms of Use which shall remain in
              full force and effect.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Waiver
            </h3>
            <p className="leading-relaxed">
              Failure by the Website to exercise any right or remedy under these
              Terms of Use does not constitute a waiver of that right or remedy.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Force Majeure
            </h3>
            <p className="leading-relaxed">
              The Website is not liable for failure to perform any of its
              obligations if such failure is as a result of Acts of God
              (including fire, flood, earthquake, storm, hurricane or other
              natural disaster), war, invasion, act of foreign enemies,
              hostilities (regardless of whether war is declared), civil war,
              rebellion, revolution, insurrection, military or usurped power or
              confiscation, terrorist activities, nationalization, government
              sanction, blockage, embargo, labor dispute, strike, lockout,
              robbery, theft of data or any interruption or any failure of
              electricity or server, system, computer, internet or telephone
              service.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-blue-500 mb-4 border-b-2 border-blue-500 pb-2">
              Contacting the Firm
            </h3>
            <p className="leading-relaxed">
              For any questions about these Terms of Use or the Privacy Policy,
              contact us at{" "}
              <a
                href="mailto:info@lextria.in"
                className="text-blue-600 hover:text-blue-800 hover:underline"
              >
                info@lextria.in
              </a>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;
